import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
} from "@mui/material";
import { get, put } from "../../../../utils/api";
import EastIcon from "@mui/icons-material/East";
import Tables from "./Tables";
import { useNavigate, useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";
import SectionHeading from "../../../../Pages/GRI/GRI300/GRI308/SectionHeading";
const LeadershipIndicator = ({ onSave, hide, removeUpload = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [errors, setErrors] = useState({});
  const [rowindex, setRowIndex] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [modalupload, setModalUpload] = useState({
    lifeInsuranceOrCompensatoryPackageDoc: false,
    statutoryDuesDeductedDepositedDoc: false,
    rehabilitatedEmploymentDetailsDoc: false,
    employabilityandmanagementDoc: false,
    assessmentYearDoc: false,
    valuechainpartnersDoc: false,
  });
  const [formData, setFormData] = useState({
    // 1
    lifeInsuranceOrCompensatoryPackage: {
      male: "Yes",
      female: "Yes",
    },
    // 2
    statutoryDuesDeductedDeposited: "",
    //  3
    rehabilitatedEmploymentDetails: {
      currentFinancialYear: {
        employee: {
          total: "",
          rehabiliatated: "",
        },
        workers: {
          total: "",
          rehabiliatated: "",
        },
      },
      previousFinancialYear: {
        employee: {
          total: "",
          rehabiliatated: "",
        },
        workers: {
          total: "",
          rehabiliatated: "",
        },
      },
    },
    //4
    employabilityandmanagement: "Yes",
    //5
    assessmentYear: {
      healthAndSafetyPractice: "",
      workingCondition: "",
    },
    //6
    valuechainpartners: "",
    lifeInsuranceOrCompensatoryPackageDoc: [],
    statutoryDuesDeductedDepositedDoc: [],
    rehabilitatedEmploymentDetailsDoc: [],
    employabilityandmanagementDoc: [],
    assessmentYearDoc: [],
    valuechainpartnersDoc: [],
  });

  const headingAssessment = [
    { title: "Category" },
    {
      title: "Total no. of affected employees/ workers",
      key: "total",
    },
    {
      title:
        "No. of employees/workers that are rehabilitated and placed in suitable employment or whose family members have been placed in suitable employment",
      key: "rehabiliatated",
    },
  ];

  const headingDetails = [
    { title: "Category" },
    {
      title:
        "% of value chain partners (by value of business done with such partners) that were assessed",
      type: "percentage",
    },
  ];

  const generateColumnValue = (title) => {
    if (title === "AssessmentsYear") {
      return [
        {
          value: "Health and safety practices",
          key: "assessmentYear.healthAndSafetyPractice",
          type: "percentage",
        },
        {
          value: "Working Conditions",
          key: "assessmentYear.workingCondition",
          type: "percentage",
        },
      ];
    } else if (title === "DetailsAssessments") {
      return [
        {
          value: "Employees",
          key: "rehabilitatedEmploymentDetails.currentFinancialYear.employee",
        },
        {
          value: "Workers",
          key: "rehabilitatedEmploymentDetails.currentFinancialYear.workers",
        },
      ];
    } else if (title === "DetailsAssessmentsPervious") {
      return [
        {
          value: "Employees",
          key: "rehabilitatedEmploymentDetails.previousFinancialYear.employee",
        },
        {
          value: "Workers",
          key: "rehabilitatedEmploymentDetails.previousFinancialYear.workers",
        },
      ];
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const [main, sub] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      [main]: sub
        ? {
            ...prev[main], // Fix: Correctly reference existing object
            [sub]: value,
          }
        : value, // Directly assign if no sub-key
    }));
  };

  const fetchData = async () => {
    await get(`/brsr/get?subType=principle3&type=SectionC&id=${id}`)
      .then((response) => {
        const res =
          response?.data?.data?.BRSRSectionC?.principle3?.leadershipIndicator;
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);

        setFormData({
          // 1
          lifeInsuranceOrCompensatoryPackage: {
            male: res?.lifeInsuranceOrCompensatoryPackage?.male ?? "Yes",
            female: res?.lifeInsuranceOrCompensatoryPackage?.female ?? "Yes",
          },
          // 2
          statutoryDuesDeductedDeposited:
            res?.statutoryDuesDeductedDeposited ?? "",
          //  3
          rehabilitatedEmploymentDetails: {
            currentFinancialYear: {
              employee: {
                total:
                  res?.rehabilitatedEmploymentDetails?.currentFinancialYear
                    ?.employee?.total === 0
                    ? 0
                    : res?.rehabilitatedEmploymentDetails?.currentFinancialYear
                        ?.employee?.total ?? "",
                rehabiliatated:
                  res?.rehabilitatedEmploymentDetails?.currentFinancialYear
                    ?.employee?.rehabiliatated === 0
                    ? 0
                    : res?.rehabilitatedEmploymentDetails?.currentFinancialYear
                        ?.employee?.rehabiliatated ?? "",
              },
              workers: {
                total:
                  res?.rehabilitatedEmploymentDetails?.currentFinancialYear
                    ?.workers?.total === 0
                    ? 0
                    : res?.rehabilitatedEmploymentDetails?.currentFinancialYear
                        ?.workers?.total ?? "",
                rehabiliatated:
                  res?.rehabilitatedEmploymentDetails?.currentFinancialYear
                    ?.workers?.rehabiliatated === 0
                    ? 0
                    : res?.rehabilitatedEmploymentDetails?.currentFinancialYear
                        ?.workers?.rehabiliatated ?? "",
              },
            },
            previousFinancialYear: {
              employee: {
                total:
                  res?.rehabilitatedEmploymentDetails?.previousFinancialYear
                    ?.employee?.total === 0
                    ? 0
                    : res?.rehabilitatedEmploymentDetails?.previousFinancialYear
                        ?.employee?.total ?? "",
                rehabiliatated:
                  res?.rehabilitatedEmploymentDetails?.previousFinancialYear
                    ?.employee?.rehabiliatated === 0
                    ? 0
                    : res?.rehabilitatedEmploymentDetails?.previousFinancialYear
                        ?.employee?.rehabiliatated ?? "",
              },
              workers: {
                total:
                  res?.rehabilitatedEmploymentDetails?.previousFinancialYear
                    ?.workers?.total === 0
                    ? 0
                    : res?.rehabilitatedEmploymentDetails?.previousFinancialYear
                        ?.workers?.total ?? "",
                rehabiliatated:
                  res?.rehabilitatedEmploymentDetails?.previousFinancialYear
                    ?.workers?.rehabiliatated === 0
                    ? 0
                    : res?.rehabilitatedEmploymentDetails?.previousFinancialYear
                        ?.workers?.rehabiliatated ?? "",
              },
            },
          },
          //4
          employabilityandmanagement: res?.employabilityandmanagement ?? "Yes",
          //5
          assessmentYear: {
            healthAndSafetyPractice:
              res?.assessmentYear?.healthAndSafetyPractice ?? "",
            workingCondition: res?.assessmentYear?.workingCondition ?? "",
          },
          //6
          valuechainpartners: res?.valuechainpartners ?? "",
          lifeInsuranceOrCompensatoryPackageDoc:
            res?.lifeInsuranceOrCompensatoryPackageDoc ?? [],
          statutoryDuesDeductedDepositedDoc:
            res?.statutoryDuesDeductedDepositedDoc ?? [],
          rehabilitatedEmploymentDetailsDoc:
            res?.rehabilitatedEmploymentDetailsDoc ?? [],
          employabilityandmanagementDoc:
            res?.employabilityandmanagementDoc ?? [],
          assessmentYearDoc: res?.assessmentYearDoc ?? [],
          valuechainpartnersDoc: res?.valuechainpartnersDoc ?? [],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const validateFields = (obj, errorsindex) => {
    let errorObj = {};

    Object.keys(errorsindex).forEach((errorKey) => {
      const nestedKeys = errorKey.split(".");
      const lastKey = nestedKeys[nestedKeys.length - 1];
      const mainKey = nestedKeys[0];
      const subKey = nestedKeys.slice(1, -1).join(".");

      // Get the value of the current field
      let fieldValue = nestedKeys.reduce((acc, key) => {
        return acc && acc[key] !== undefined ? acc[key] : undefined;
      }, obj);

      // Get the parent object to validate sibling fields
      const parentPath = nestedKeys.slice(0, -1);
      const parentObj = parentPath.reduce((acc, key) => {
        return acc && acc[key] !== undefined ? acc[key] : undefined;
      }, obj);

      const isValid = fieldValue !== undefined && fieldValue !== "";

      // If the field is missing but any sibling field has value, throw an error
      if (parentObj && typeof parentObj === "object") {
        const siblingValues = Object.entries(parentObj);
        const anySiblingHasValue = siblingValues.some(
          ([key, val]) => key !== lastKey && val !== "" && val !== undefined
        );

        if (!isValid && anySiblingHasValue) {
          if (!errorObj[mainKey]) errorObj[mainKey] = [];

          errorObj[mainKey].push({
            subKey,
            fieldName: lastKey,
            rowIndex: errorsindex[errorKey]?.rowIndex + 1 || "-",
            message:
              "All fields in this section must be filled if any one is filled",
          });

          return;
        }
      }

      // Default required field validation (if no sibling has value either)
      if (!isValid && !parentObj) {
        if (!errorObj[mainKey]) errorObj[mainKey] = [];

        errorObj[mainKey].push({
          subKey,
          fieldName: lastKey,
          rowIndex: errorsindex[errorKey]?.rowIndex + 1 || "-",
          message: "This field is required",
        });
      }
    });
    setErrors(errorObj);
    return Object.keys(errorObj).length > 0 ? errorObj : false;
  };

  const handleClick = async () => {
    // if(!validate()) return;
    if (!disabled) {
      if (validateFields(formData, rowindex)) return;

      let transformedData = {
        leadershipIndicator: {
          ...formData,
        },
        leadershipIndicatorSubmitted: true,
        type: "SectionC",
        subType: "principle3",
      };
      try {
        const res = await put(`/brsr/update?id=${id}`, transformedData);
        navigate(`/brsr/section-c/principle4/${id}`);
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else navigate(`/brsr/section-c/principle4/${id}`);
  };
  return (
    <div>
      <Typography
        variant="h6"
        sx={{
          textDecoration: "underline",
          textTransform: "uppercase",
          fontWeight: "bold",
          margin: "15px 0",
        }}
      >
        II. Leadership Indicator
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        1. Does the entity extend any life insurance or any compensatory package
        in the event of death of Employees & Workers.
      </Typography>
      <Box sx={{ display: "flex" , ml:2}}>
        <Box>
          <Typography sx={{ mt: 2 }}>a.Employees</Typography>
          <RadioGroup
            disabled={disabled}
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "0px",
              padding: "0px 5px",
            }}
            name="lifeInsuranceOrCompensatoryPackage.male"
            values={formData?.lifeInsuranceOrCompensatoryPackage?.male}
            onChange={handleChange}
            defaultValue="Yes" // Set the default selected value
          >
            {["Yes", "No"].map((item, index) => (
              <FormControlLabel
                key={index}
                control={<Radio value={item} disabled={disabled} />}
                label={item}
              />
            ))}
          </RadioGroup>
        </Box>
        <Box>
          <Typography sx={{ mt: 2 }}>b.Workers</Typography>
          <RadioGroup
            disabled={disabled}
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "0px",
              padding: "0px 5px",
            }}
            name="lifeInsuranceOrCompensatoryPackage.female"
            values={formData?.lifeInsuranceOrCompensatoryPackage?.female}
            onChange={handleChange}
            defaultValue="Yes" // Set the default selected value
          >
            {["Yes", "No"].map((item, index) => (
              <FormControlLabel
                key={index}
                control={<Radio value={item} disabled={disabled} />}
                label={item}
              />
            ))}
          </RadioGroup>
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "lifeInsuranceOrCompensatoryPackageDoc",
          ml: 3,
          removeUpload,
        }}
      />
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", margin: "15px 0" }}
          gutterBottom
        >
          2. Provide the measures undertaken by the entity to ensure that
          statutory dues have been deducted and deposited by the value chain
          partners.
        </Typography>
        <TextField
          placeholder="Type Here"
          disabled={disabled}
          // fullWidth
          sx={{ml:2,width:"98%"}}
          name="statutoryDuesDeductedDeposited"
          value={formData?.statutoryDuesDeductedDeposited}
          onChange={handleChange}
          minRows={1}
          multiline
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "statutoryDuesDeductedDepositedDoc",
          ml: 3,
          removeUpload,
        }}
      />
      <Box>
       
        <SectionHeading text= {` 3. Provide the number of employees / workers having suffered high
          consequence work- related injury / ill-health / fatalities (as
          reported in Q11 of Essential Indicators above), who have been are
          rehabilitated and placed in suitable employment or whose family
          members have been placed in suitable employment:`} />
       <Box sx={{ml:2}}> <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", margin: "15px 0" }}
          gutterBottom
        >
          a. Current Financial Year
        </Typography>
     
       <Tables
          heading={headingAssessment}
          columnWidth={"25% 34% 41%"}
          // columnValue={columnValue}
          disabled={disabled}
          columnValue={generateColumnValue("DetailsAssessments")}
          // title={"Other than Permanent Workers"}
          formValues={formData}
          errorsindex={rowindex}
          setRowIndex={setRowIndex}
          setFormValues={setFormData}
          errors={errors?.rehabilitatedEmploymentDetails?.filter((item) =>
            `${item.subKey}`.includes("currentFinancialYear")
          )}
          // topheader={"20.Details at the end of Financial Year"}
        />
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", margin: "15px 0" }}
          gutterBottom
        >
          b. Previous Financial Year
        </Typography>
        <Tables
          disabled={disabled}
          heading={headingAssessment}
          columnWidth={"25% 34% 41%"}
          // columnValue={columnValue}
          columnValue={generateColumnValue("DetailsAssessmentsPervious")}
          // title={"Other than Permanent Workers"}
          formValues={formData}
          errorsindex={rowindex}
          setRowIndex={setRowIndex}
          setFormValues={setFormData}
          errors={errors?.rehabilitatedEmploymentDetails?.filter((item) =>
            `${item.subKey}`.includes("previousFinancialYear")
          )}
          // topHeading={"Permanent Employees"}
          // topheader={"20.Details at the end of Financial Year"}
        />
         </Box> 
      </Box>
      <Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "rehabilitatedEmploymentDetailsDoc",
            ml: 3,
            removeUpload,
          }}
        />
        <SectionHeading text={` 4. Does the entity provide transition assistance programs to facilitate
          continued employability and the management of career endings resulting
          from retirement or termination of employment?`}/>
        <RadioGroup
          disabled={disabled}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "0px",
            padding: "0px 5px",
            ml:2
          }}
          name={"employabilityandmanagement"}
          value={formData?.employabilityandmanagement}
          onChange={handleChange}
          defaultValue="Yes" // Set the default selected value
        >
          {["Yes", "No"].map((item, index) => (
            <FormControlLabel
              key={index}
              control={<Radio value={item} disabled={disabled} />}
              label={item}
            />
          ))}
        </RadioGroup>
      </Box>
      <Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "employabilityandmanagementDoc",
            ml: 3,
            removeUpload,
          }}
        />
       
        <SectionHeading text={"5. Details on assessment of value chain partners:"}/>
       <Box sx={{ml:2}}> <Tables
          disabled={disabled}
          heading={headingDetails}
          columnWidth={"25% 75%"}
          // columnValue={columnValue}
          columnValue={generateColumnValue("AssessmentsYear")}
          // title={"Other than Permanent Workers"}
          formValues={formData}
          setFormValues={setFormData}
          // errors={
          //   errors?.rehabilitatedEmploymentDetails?.filter((item) =>
          //     `${item.subkey}`.includes("currentFinancialYear.employee")
          //   ) || ""
          // }
          // topHeading={"Permanent Employees"}
          // topheader={"20.Details at the end of Financial Year"}
        />
        <Box></Box>
        </Box>
      </Box>
      <Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "assessmentYearDoc",
            ml: 3,
            removeUpload,
          }}
        />
        <SectionHeading text={` 6. Provide details of any corrective actions taken or underway to
          address significant risks / concerns arising from assessments of
          health and safety practices and working conditions of value chain
          partners.`}/>
        <TextField
          disabled={disabled}
          placeholder="Type Here"
          // fullWidth
          sx={{ml:2,width:"98%"}}
          name="valuechainpartners"
          value={formData?.valuechainpartners}
          onChange={handleChange}
          minRows={1}
          multiline
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "valuechainpartnersDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ width: "100%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleClick}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleClick}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </div>
  );
};

export default LeadershipIndicator;
